import { render, staticRenderFns } from "./UpdateStatusForm.vue?vue&type=template&id=f2ae6610&"
import script from "./UpdateStatusForm.vue?vue&type=script&lang=js&"
export * from "./UpdateStatusForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports